class BackgroundProcessService extends BaseService
	@registerService()
	@inject '$filter',
		'$rootScope'
		'$window'
		'$q'
		'ReportRepository'
		'MessageTerminal'
		'BACKEND_QUEUE_TASK_STATUS'

	waitTime: 5000
	task: null

	init: (reportType, filter, format, email = null) ->
		if @isLoading()
			return @$q.reject({data: error: {'Download already initiated'}})

		@task = {}
		@type = reportType
		@$rootScope.ignoreLoader = true

		@start(reportType, filter, format, email)
			.then => @wait()
			.catch (response) => @error(response)
			.finally =>
				@$rootScope.ignoreLoader = false

	isLoading: ->
		return @task != null

	start: (reportType, filter, format, email = null) ->
		data = {}

		if filter?
			data = JSON.parse(JSON.stringify(filter))

			@filterData data

		data.format = format if format?

		model =
			email: email
			data: data

		return @ReportRepository
			.post reportType, model
			.then (response) =>
				@task = response.data
				@MessageTerminal.publish @MessageTerminal.events.BACKGROUND_PROCESS.START, angular.copy(@task)
			.catch (response) =>
				@error response

	filterData: (data) ->
		return if not data?

		for own key, value of data
			delete data[key] if not value? || _.isEmpty('' + value)
			data[key] = value.unix() if moment.isMoment value
			@filterData(data[key]) if typeof data[key] == 'object'

	wait: (iteration = 1) ->
		if not @task.id?
			@error('Missing task ID')

			return

		@ReportRepository
			.getEntity(@task.id)
			.then (response) =>
				switch response.status
					when @BACKEND_QUEUE_TASK_STATUS.FINISHED then @download(response.report?.files[0]?.id)
					when @BACKEND_QUEUE_TASK_STATUS.FAILED then @error("Download failed. #{response.comment}")
					else
						if iteration > 10
							console.warn(@constructor.name + ' Reached iterations limit')

						setTimeout(
							=>
								@MessageTerminal.publish @MessageTerminal.events.BACKGROUND_PROCESS.WAIT, angular.copy(@task)
								@wait(iteration + 1)
							,
							@waitTime * iteration
						)
			.catch (response) => @error(response)

	download: (fileId) ->
		return @error('Missing file ID') if not fileId?

		@ReportRepository
			.download fileId
			.then => @afterComplete(fileId)
			.catch (response) => @error(response)

	afterComplete: ->
		@MessageTerminal.publish @MessageTerminal.events.BACKGROUND_PROCESS.COMPLETE, angular.copy(@task)

		@unload()

	error: (response) ->
		if response.data?
			response = response.data

			if response.error?
				response = response.error

		@MessageTerminal.publish @MessageTerminal.events.BACKGROUND_PROCESS.ERROR, @type, angular.copy(@task), response

		@unload()

	unload: ->
		@task = null
